export { default as DocumentationTab } from './DocumentationTab';
export { default as DraftsTab } from './DraftsTab';
